import { useTranslation } from "react-i18next";
import NoDataSvg from "../../assets/svg/NoData.svg";

const NoData = (props?: any) =>
{
  const { t } = useTranslation();
  return (
    <div className="w-full h-full flex flex-col items-center text-center justify-center ">
      <img src={NoDataSvg} width={props?.widthImage} />

      <p
        className="uppercase font-semibold mt-6 text-xl text-[var(--color-text-footer)]"
        style={{ fontSize: props?.fontText ?? "28px", lineHeight: "42px" }}
      >
        {t("No data")}
      </p>

      {props?.extraButton && props?.extraButton}
    </div>
  );
};

export default NoData;
